import { mapSiteModelToDto } from '@hotjar/site';
import type { Site } from '@hotjar/site';

export const updateLocalStorageUserdata = (sites: Array<Site>, siteId: number): void => {
  const newSite = sites.find((site) => site.id === siteId);

  const cachedUserData = localStorage.getItem('userData');

  if (!cachedUserData) {
    // TODO: Maybe we should just log the user out.
    throw new Error('No cached user data found');
  }

  const userdata = JSON.parse(cachedUserData);

  if (!userdata) {
    throw new Error('No cached user data found');
  }

  if (!newSite) {
    return;
  }

  userdata.currentSite = mapSiteModelToDto(newSite);

  localStorage.setItem('userData', JSON.stringify(userdata));
};
